import React, { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function LanguageSwitcher({ variant = "default", testid = "lang-switcher" }) {
    const { lang, setLang, languages, t } = useI18n();
    const [open, setOpen] = useState(false);

    const base =
        variant === "ghost"
            ? "inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground rounded-full px-3 py-1.5"
            : "inline-flex items-center gap-1.5 glass rounded-full px-3 h-9 text-sm transition hover:text-accent";

    return (
        <div className="relative">
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                onBlur={() => setTimeout(() => setOpen(false), 150)}
                className={base}
                data-testid={testid}
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <span>{t("change_language")}</span>
                <ChevronDown className="w-3.5 h-3.5 opacity-60" />
            </button>
            {open && (
                <div
                    className="absolute right-0 mt-2 w-48 glass-strong rounded-2xl p-1.5 z-50 fade-up origin-top-right"
                    role="listbox"
                    data-testid={`${testid}-menu`}
                >
                    {languages.map((l) => (
                        <button
                            key={l.code}
                            type="button"
                            onMouseDown={(e) => { e.preventDefault(); setLang(l.code); setOpen(false); }}
                            className={`w-full flex items-center justify-between gap-3 px-3 py-2 text-sm rounded-xl transition ${lang === l.code ? "bg-accent/10 text-accent" : "hover:bg-secondary"}`}
                            data-testid={`${testid}-opt-${l.code}`}
                            role="option"
                            aria-selected={lang === l.code}
                        >
                            <span className="flex flex-col items-start">
                                <span className="font-medium">{l.native}</span>
                                <span className="text-[11px] text-muted-foreground">{l.name}</span>
                            </span>
                            {lang === l.code && <Check className="w-4 h-4" />}
                        </button>
                    ))}
                    <div className="px-3 pt-2 pb-1 text-[10px] text-muted-foreground border-t border-border/60 mt-1">
                        {t("language")}
                    </div>
                </div>
            )}
        </div>
    );
}
